import { render, staticRenderFns } from "./RecordSearchModal.vue?vue&type=template&id=72ae1184&scoped=true&"
import script from "./RecordSearchModal.vue?vue&type=script&lang=js&"
export * from "./RecordSearchModal.vue?vue&type=script&lang=js&"
import style0 from "./RecordSearchModal.vue?vue&type=style&index=0&id=72ae1184&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72ae1184",
  null
  
)

export default component.exports